export default "__VITE_ASSET__DLaC$pmu__"